$(document).ready(function(){

    $(window).scroll(function(){

        $('.step-box-1').each(function(){

        	var offsetTopPosition = $(this).offset().top - $(window).scrollTop();

        	if (offsetTopPosition < 300) {
                $(this).addClass('entranceanimation');
        	}

        	

        });

    });

$(window).scroll(function(){

        $('.step-box-2').each(function(){

        	var offsetTopPosition = $(this).offset().top - $(window).scrollTop();

        	if (offsetTopPosition < 300) {
                $(this).addClass('entranceanimation2');
        	}

        	

        });

    });
  
$(window).scroll(function(){

        $('.step-box-3').each(function(){

        	var offsetTopPosition = $(this).offset().top - $(window).scrollTop();

        	if (offsetTopPosition < 300) {
                $(this).addClass('entranceanimation3');
        	}

        	

        });

    });
});
